import { ViewConfig } from "@lib/views";
import { DATE_COLUMN_SIZE } from "@design-system/ViewTable/DefaultColumnSizes";
import { AuditLogChangeType } from "@common/types/auditLog";
import {
    RuleGroupType,
    TransactionRuleCondition,
} from "@common/types/transactionRule";
import { RuleHistoryDateCell } from "../cells/RuleHistoryDateCell";
import { RuleHistorySummaryCell } from "../cells/RuleHistorySummaryCell";

export interface RuleHistoryListRow {
    id: string;
    logId: string;
    date: Date;
    changeType: AuditLogChangeType;
    ruleGroupName: string;
    ruleType: RuleGroupType;
    ruleResourceId: string;
    conditions: TransactionRuleCondition[];
    conditionTexts: string[];
}

export const RULE_GROUP_TYPE_LABELS: Record<RuleGroupType, string> = {
    [RuleGroupType.TRANSACTION]: "Transaction",
    [RuleGroupType.ACCOUNTING]: "Accounting",
    [RuleGroupType.TRANSFER]: "Transfer",
    [RuleGroupType.SPLIT]: "Split",
};

export enum RuleHistoryListColumn {
    TIME = "time",
    RULE_TYPE = "ruleType",
    RULE_GROUP = "ruleGroup",
    RULE_SUMMARY = "ruleSummary",
}

export const ruleHistoryListViewConfig: ViewConfig<
    RuleHistoryListRow,
    RuleHistoryListColumn,
    never
> = {
    columns: {
        [RuleHistoryListColumn.TIME]: {
            accessorKey: "date",
            name: "Time",
            header: "",
            cell: RuleHistoryDateCell,
            immutable: true,
            ...DATE_COLUMN_SIZE,
        },
        [RuleHistoryListColumn.RULE_TYPE]: {
            accessorKey: "ruleType",
            name: "Rule type",
            header: "Rule type",
            cell: ({ getValue }) => {
                const type = getValue() as RuleGroupType;
                return RULE_GROUP_TYPE_LABELS[type] ?? type;
            },
            minSize: 100,
            maxSize: 140,
        },
        [RuleHistoryListColumn.RULE_GROUP]: {
            accessorKey: "ruleGroupName",
            name: "Rule group",
            header: "Rule group",
            minSize: 200,
            maxSize: 220,
        },
        [RuleHistoryListColumn.RULE_SUMMARY]: {
            accessorKey: "ruleResourceId",
            name: "Rule",
            header: "Rule",
            cell: RuleHistorySummaryCell,
            minSize: 200,
            maxSize: 900,
        },
    },
};

export { RuleGroupType };
